import UserOverview from "@/views/App/Holiday/Overview/UserOverview.vue";
import CurrentUserOverview from "@/views/App/Holiday/Overview/CurrentUserOverview.vue";
import UserList from "@/views/App/Holiday/UserList/List.vue";
import PendingRequestList from "@/views/App/Holiday/PendingRequest/List.vue";
import {UserRole} from "@/shared/enums/UserRolesEnums";

const routesHoliday = [
    {
        path: 'current-user-overview',
        name: 'holidayCurrentUserOverview',
        component: CurrentUserOverview
    },
    {
        path: 'user-overview/:overviewUserId',
        name: 'holidayUserOverview',
        component: UserOverview
    },
    {
        path: 'user-list',
        name: 'holidayUserList',
        component: UserList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES
            ]
        },
    },
    {
        path: 'pending-request',
        name: 'holidayPendingRequestList',
        component: PendingRequestList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES
            ]
        },
    },
];

export default routesHoliday;